export const MEMBER_TYPES = {
  EARNED: 0,
  USED: 1,
};

export const SOURCE_TYPES = {
  UNKNOWN: 0, // 未知
  ORDER: 1, // 订单
  REFUND: 2, // 退款
  REDEEM_GIFT_CARD: 3, // 兑换礼品卡
  SYSTEM_TOP_UP: 4, // 系统充值
  EXPIRED: 5, // 过期
};

export const DISCOUNT_CODE_TYPES = {
  BASIC: 1, // 基础折扣
  FREE_SHIPPING: 2, // 免运费折扣
};

// export const USERS = {
//   MY_ID: 8159852724470,
//   ID1: 8174833860854,
//   ID2: 8003419275510,
// };

export const GIFT_CARD_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

export const COUPON_STATUS = {
  AVAILABLE: 1,
  UNAVAILABLE: 2,
};

export interface AvailableGiftCardItem {
  id: number;
  type: number;
  value: number;
  amount: string;
  points: number;
  amountText: string;
}

// 可用的礼品卡
export const availableGiftCards: AvailableGiftCardItem[] = [
  {
    id: 1,
    type: 1,
    value: 5,
    amount: "$5.00",
    amountText: "US $5.00",
    points: 100,
  },
  {
    id: 2,
    type: 2,
    value: 15,
    amount: "$15.00",
    amountText: "US $15.00",
    points: 300,
  },
  {
    id: 3,
    type: 3,
    value: 25,
    amount: "$25.00",
    amountText: "US $25.00",
    points: 500,
  },
];
